import React, { Component } from 'react';
import { Divider, Switch, Slider, Button, FormGroup } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Notification extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      AlchemyNotice: true,
      AlchemyNoticePlus: 8,
      AlchemyNoticeMessage:
        'Congratulations {charname}, your item {itemname} upgraded to +{plus} !!',
      WelcomeNotice: true,
      WelcomeNoticeMessage:
        'You are welcome {charname}, you can check your score board on www.srofilter.com',
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Notification
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td>Alchemy Congratulate</td>
              <td>
                <Switch
                  checked={this.state.AlchemyNotice}
                  {...SwitchOnOff}
                  onChange={this.handleChange('AlchemyNotice')}
                />
              </td>
            </tr>

            <tr>
              <td>Alchemy Notice After Plus</td>
              <td>
                <Slider
                  disabled={!this.state.AlchemyNotice}
                  min={0}
                  max={255}
                  labelStepSize={30}
                  onChange={this.handleChange('AlchemyNoticePlus')}
                  value={this.state.AlchemyNoticePlus}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>Alchemy Notice Message</td>
              <td style={{ minWidth: '320px' }}>
                <FormGroup
                  helperText="Parameters: {charname}, {itemname}, {plus}"
                  className="mb-0"
                >
                  <input
                    disabled={!this.state.AlchemyNotice}
                    className="bp3-input d-block w-100"
                    placeholder="Type an message..."
                    value={this.state.AlchemyNoticeMessage}
                    onChange={this.handleChange('AlchemyNoticeMessage')}
                    min={20}
                    max={120}
                  />
                </FormGroup>
              </td>
            </tr>

            <tr>
              <td>Welcome Notice</td>
              <td>
                <Switch
                  checked={this.state.WelcomeNotice}
                  {...SwitchOnOff}
                  onChange={this.handleChange('WelcomeNotice')}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>Welcome Message</td>
              <td>
                <FormGroup helperText="Parameters: {charname}" className="mb-4">
                  <input
                    disabled={!this.state.WelcomeNotice}
                    placeholder="Type a message..."
                    value={this.state.WelcomeNoticeMessage}
                    onChange={this.handleChange('WelcomeNoticeMessage')}
                    min={20}
                    max={120}
                    className="bp3-input d-block w-100"
                  />
                </FormGroup>
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
